var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4945 16.0911C12.0409 15.3566 11.7743 14.493 11.7743 13.5651C11.7743 12.756 11.9758 11.9949 12.3277 11.3257L12.3166 11.309C13.0256 10.2412 13.4402 8.95963 13.4402 7.58023C13.4402 3.86133 10.4374 0.846741 6.73381 0.846741C3.02985 0.846741 0.0273743 3.86133 0.0273743 7.58023C0.0273743 8.30654 0.145106 9.00461 0.35735 9.66033C0.499935 10.2487 0.729839 10.8013 1.03365 11.3057L1.00226 11.3238L5.85998 19.7719C6.37276 21.2954 7.80483 22.3934 9.49493 22.3934C11.6154 22.3934 13.3353 20.6676 13.3353 18.5383C13.3353 17.6146 13.0108 16.7671 12.4709 16.1032L12.4945 16.0911Z",
    fill: "#F0EAE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoot);
export default __webpack_public_path__ + "static/media/foot.1357c6c6a446f1a1e4a223a320e9e019.svg";
export { ForwardRef as ReactComponent };